// PROPOSITO: las rutas de Flor. Su panel es una bandeja de triaje, no una tabla (patron TrueCoach).
// DEPENDENCIAS: react-router-dom, EntrenadoraLayout, Guard.

import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'
import { Guard } from './Guard'
import { EntrenadoraLayout } from '@/layouts/EntrenadoraLayout'

const Panel = lazy(() => import('@/pages/entrenadora/Panel'))
const Cartera = lazy(() => import('@/pages/entrenadora/Cartera'))
const FichaDeAlumna = lazy(() => import('@/pages/entrenadora/FichaDeAlumna'))
const BibliotecaEjercicios = lazy(() => import('@/pages/entrenadora/BibliotecaEjercicios'))
const BibliotecaMenus = lazy(() => import('@/pages/entrenadora/BibliotecaMenus'))
const ArmarPrograma = lazy(() => import('@/pages/entrenadora/ArmarPrograma'))
const Cobros = lazy(() => import('@/pages/entrenadora/Cobros'))

export const rutasDeEntrenadora: RouteObject[] = [
  {
    element: <Guard permitidos={['entrenadora']} />,
    children: [
      {
        element: <EntrenadoraLayout />,
        children: [
          { path: '/panel', element: <Panel /> },
          { path: '/alumnas', element: <Cartera /> },
          { path: '/alumnas/:alumnaId', element: <FichaDeAlumna /> },
          { path: '/alumnas/:alumnaId/programa', element: <ArmarPrograma /> },
          { path: '/ejercicios', element: <BibliotecaEjercicios /> },
          { path: '/menus', element: <BibliotecaMenus /> },
          { path: '/cobros', element: <Cobros /> },
        ],
      },
    ],
  },
]
